export default "__VITE_ASSET__CcPYV3TF__"